import React, { useEffect } from 'react';
import animateScrollTo from 'animated-scroll-to';
import Button from '../../../common/button/Button';

const AboutUs = () => {
    useEffect(() => {
        animateScrollTo(0, { speed: 700 });
    }, []);

    return (
        <section className="SectionAboutUs">
            <header>
                <h1>Sobre a rádio </h1>
                <p className="pageSubtitle">Há mais de cinco décadas no ar </p>
            </header>
            <div className="aboutUsContent">
                <img src="/imgAboutUsPage/sobre-nos.jpg" title="Banner Sede Antena1" alt="Banner Antena1" className="aboutUsBanner" />
                <p>
                    Muito antes do fenômeno da globalização chegar à América do Sul,
                    a Antena 1 já aproximava milhares de brasileiros dos sucessos, tendências musicais e notícias mundiais.
                    Fundada em setembro de 1975, a Antena 1 surgiu como a primeira rádio FM comercial a investir em uma programação própria,
                    exclusiva e diferenciada. Ou seja, enquanto o mercado utilizava a programação das AMs para suprir as FMs,
                    a Antena 1 apostou em uma nova linguagem.
                </p>
                <p>
                    A Antena 1 sempre apostou nas inovações tecnológicas. No início da década de 90,
                    contratou o uso de um canal via satélite para transmissão em rede e implantou softwares de última geração.
                    Percebeu, assim, que a formação de uma rede via-satélite seria a oportunidade do rádio retomar seu lugar
                    de prestígio junto aos anunciantes.
                    Com isso, investiu na formação de parcerias com emissoras locais em diversas regiões do Brasil,
                    sempre com o objetivo de criar uma grande rede nacional.
                </p>
                <p>
                    A Antena 1 foi a primeira rede de emissoras FM do Brasil a operar de forma automática via satélite,
                    com a mesma programação irradiada real time, por 24 horas.
                    Hoje, a empresa soma 25 emissoras espalhadas pelas principais capitais brasileiras e oferece a
                    milhões de ouvintes em cerca de 700 municípios,
                    56 minutos de música por hora. Faz também parte do Grupo a Radio Antenna Uno, de Roma, na Itália.
                </p>
                <p>
                    Com uma rede unificada e uma programação especializada, para um público altamente qualificado e exigente,
                    a Antena 1 é sinônimo de qualidade e bom gosto musical. Afinal, ela traz o melhor do mundo para o seu rádio.
                </p>
            </div>
            <div className="buttonsContainer">
                <Button title="Conheça os nossos programas" to="/programacao" className="aboutUsButton">
                    Conheça os nossos programas
                </Button>
                <Button title="Conheça as nossas filiais" to="/afiliadas" className="aboutUsButton">
                    Conheça as nossas filiais
                </Button>
            </div>
        </section>
    );
};


export default AboutUs;
